import React, { useEffect } from "react";
import { Col, Container, Row } from 'reactstrap';
import { reduxForm } from 'redux-form';
import Default from './components/Default';

const RIPS = ({ history, location }) => {

    useEffect(() => {

    }, []);

    return (
        <Container className="dashboard">
            <Row>
                <Col md={12}>
                    <h3 className="page-title center-title">RIPS</h3>
                </Col>
            </Row>
            <Default />
        </Container>
    );
}
export default reduxForm({
    form: 'rips_form',
})(RIPS);